export type BibleGenreType = {
    law: 1,
    history: 2,
    poetry: 3,
    majorProphets: 4,
    minorProphets: 5,
    gospels: 6,
    paulineEpistles: 7,
    epistles: 8,
    prophecy: 9,
}

export const BibleGenres: BibleGenreType = {
    law: 1,
    history: 2,
    poetry: 3,
    majorProphets: 4,
    minorProphets: 5,
    gospels: 6,
    paulineEpistles: 7,
    epistles: 8,
    prophecy: 9,
}

export type BibleGenresValues = typeof BibleGenres[keyof typeof BibleGenres]

export const AllBibleGenres: BibleGenresValues[] = Array.from(Object.values(BibleGenres));

export const BibleGenreNames: { [key in BibleGenresValues]: string } = {
    [BibleGenres.law]: 'Law',
    [BibleGenres.history]: 'History',
    [BibleGenres.poetry]: 'Poetry',
    [BibleGenres.majorProphets]: 'Major Prophets',
    [BibleGenres.minorProphets]: 'Minor Prophets',
    [BibleGenres.gospels]: 'Gospels',
    [BibleGenres.paulineEpistles]: 'Pauline Epistles',
    [BibleGenres.epistles]: 'Epistles',
    [BibleGenres.prophecy]: 'Prophecy',
}